function DynamicComponentService(Vue, options, app) {
    if (!(this instanceof DynamicComponentService)) {
        return new DynamicComponentService(Vue, options, app);
    }

    function createElement(component, properties) {
        var ComponentClass = Vue.extend(component);
        var instance = new ComponentClass(properties);
        instance.$mount();
        return instance;
    }

    function showElement(component, properties, container) {
        let instance = createElement(component, properties);
        (container || document.body).appendChild(instance.$el);
        return instance;
    }

    this.createElement = createElement;
    this.showElement = showElement;
}

function install(Vue, options) {
    let dc;

    Object.defineProperties(Vue.prototype, {
        $dynamic: {
            get() {
                return dc;
            }
        }
    });

    Vue.mixin({
        beforeCreate() {
            dc = dc || new DynamicComponentService(Vue, options, this);
        }
    });
}

export default install;